<template>
  <div style="flex: 1; padding: 20px min-height:20%">
    <el-row>
      <el-button
        v-if="checkPermission('createRole')"
        style="float: right; margin-right: 30px"
        @click="create()"
        >{{ $t("admin.create") }}</el-button
      >
    </el-row>
    <br />
    <el-card>
      <el-table v-loading="roles.loading" :data="roles.data">
        <!-- <el-table-column prop="name" :label="'Name'"></el-table-column> -->
        <el-table-column
          prop="name"
          :label="$t('admin.role')"
        ></el-table-column>
        <el-table-column
          prop="displayName"
          :label="$t('admin.roleOverview')"
        ></el-table-column>
        <el-table-column width="auto" :label="$t('admin.actions')" id="action">
          <template slot-scope="scope">
            <el-button size="small" @click="Edit(scope.row._id, 'assign')">{{
              $t("admin.assignUsers")
            }}</el-button>
            <el-button
              v-if="checkPermission('updateRole')"
              size="small"
              @click="Edit(scope.row._id, 'edit')"
              >{{ $t("admin.edit") }}</el-button
            >
            <el-button
              v-if="checkPermission('deleteRole')"
              size="small"
              type="danger"
              @click="Delete(scope.row.name)"
              >{{ $t("admin.delete") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- Create form start -->

    <AdminTabRoleCreate
      :title="$t('admin.createRoles')"
      class="dialogCreatePermission"
      :visible.sync="showCreateForm"
      width="70%"
      @created="showCreateForm = false"
    />

    <!-- Create form Finish -->

    <!-- Edit form start -->

    <AdminTabRoleEdit
      width="70%"
      :title="$t('admin.editRoles')"
      :visible.sync="showEditForm"
      @edited="showEditForm = false"
      :permission="editForm"
    />
    <!-- Edit form Finish -->
    <!-- assign form start -->
    <el-dialog
      width="70%"
      :title="$t('admin.assignUsers')"
      ref="ruleForm"
      :visible.sync="showAssignForm"
    >
      <AdminTabRoleAssign
        :permission="editForm"
        :showAssignForm="showAssignForm"
        @assigned="showAssignForm = false"
      />
    </el-dialog>
    <!-- assign form Finish -->
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import AdminTabRoleCreate from "./AdminTab_Role_Create";
import AdminTabRoleEdit from "./AdminTab_Role_Edit";
import AdminTabRoleAssign from "./AdminTab_Role_Assign";

export default {
  name: "Admin",
  components: {
    AdminTabRoleCreate,
    AdminTabRoleEdit,
    AdminTabRoleAssign,
  },
  data() {
    return {
      results: {},
      formLoading: false,
      createFormLoading: false,
      editFormLoading: false,
      showForm: false,
      showAssignForm: false,
      showCreateForm: false,
      showEditForm: false,
      editForm: {},
    };
  },
  created() {
    this.getRoles();
    this.getPermissions();
  },
  computed: {
    ...mapState("admin", ["roles", "permissions"]),
    resultsTable() {
      return Object.keys(this.results);
    },
  },
  watch: {},
  methods: {
    sanitize(name) {
      this.createForm.name = name
        .trim()
        .toUpperCase()
        .replace(/[^a-zA-Z _]/g, "");
    },
    ...mapActions("admin", ["getRoles", "getPermissions", "deleteRole"]),
    Delete(name) {
      this.$confirm(this.$t("admin.warningtext"), this.$t("admin.warning"), {
        confirmButtonText: this.$t("admin.warningConfirmText"),
        cancelButtonText: this.$t("admin.warningCancelText"),
        type: "warning",
      })
        .then(() => this.deleteRole(name))
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("admin.warningDeleteCancel"),
          });
        });
    },
    create() {
      this.showCreateForm = true;
    },
    Edit(id, title) {
      const editRole = this.roles.data.find((x) => x._id == id);
      this.editForm = {};
      if (editRole) {
        this.editForm = editRole;
      }
      if (title == "edit") {
        this.showEditForm = true;
      } else {
        this.showAssignForm = true;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.el-dialog {
  margin-top: 15vh !important;
}
p {
  margin-left: 30px;
}
.el-form-item__content label.country-selector__label {
  line-height: normal;
}

.el-form-item__content label.input-tel__label {
  line-height: normal;
}
</style>
<style scoped>
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}

.tabs {
  flex-basis: 80%;
  display: flex;
}
.component {
  padding: 10px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
}
.component-container {
  margin: 0 10px 20px 10px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  min-width: 300px;
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  flex: 1 0 48%;
}
</style>